<div>
  @if (!showLoader) {
  <div class="avatar-info">
    <div class="base-info">
      <div class="base-info__avatar">
        <span
          class="user-avatar"
          [ngStyle]="{
            width: '60px',
            'min-width': '60px',
            height: '60px'
          }"
        >
          @if (!avatarDetails?.profile) {
          <span class="font-26">{{
            avatarDetails?.firstname?.charAt(0)?.toUpperCase() +
              "" +
              avatarDetails?.lastname?.charAt(0)?.toUpperCase()
          }}</span>
          }
          @if (avatarDetails?.profile) {
          <img
            [src]="avatarDetails?.profile"
            alt=""
          />
          }
        </span>
      </div>
      <div class="base-info__details">
        <h4 class="base-info__name">
          {{ avatarDetails?.firstname }} {{ avatarDetails?.lastname }}
        </h4>
      </div>
    </div>
  </div>
  } @else {
    <div class="avatar-popup-loader">
      <nz-spin nzSimple></nz-spin>
    </div>
  }
</div>
